import { Image } from '@codes/ui-kit/components/ui/image';

import { Dialog, DialogContent, DialogTitle, DialogTrigger } from '@codes/ui-kit';

export const ImageItem = ({ fileUrl }: { fileUrl: string | undefined }) => {
    return (
        <Dialog>
            <DialogTrigger asChild>
                <button
                    type="button"
                    className="w-[72px] h-[72px] rounded-[10px] overflow-hidden bg-input border border-text-400"
                >
                    <Image className="w-full h-full object-cover" src={fileUrl} alt={`${fileUrl} - Trigger`} />
                </button>
            </DialogTrigger>
            <DialogContent className="p-0">
                <DialogTitle />
                <Image className="w-full h-full object-contain" src={fileUrl} alt={`${fileUrl} - Content`} />
            </DialogContent>
        </Dialog>
    );
};
